import React from 'react';
import { ScoreCard, ScoreCardBlank } from '../../cards';
import { renderRoundLabel, shouldDisplayRoundNumbers, isEventOfficialHsEvent, EventTypes } from '../../../utils/events';

const Round = (props) => {
    const {
        selectedDraw,
        round,
        teamsDict,
        playersDict,
        isCurrentMemberAdmin,
        utrType,
        eventSchedule,
        columnNumber,
        displayOnMobile,
        showMatchDates,
        events,
    } = props;

    const {
        eliminationType,
        drawFormatType,
        rounds,
        ballType,
    } = selectedDraw;

    const orderOfPlay = events.currentEvent?.orderOfPlay;
    const isOfficialHSEvent = isEventOfficialHsEvent(events.currentEvent?.data);
    const isFlexLeagueEvent = events.currentEvent?.data?.eventType?.id === EventTypes.FLEX_LEAGUE;
    const { sportTypeId } = events.currentEvent?.data || {};

    return (
        <div
            className={`col-md-4 d-none ${displayOnMobile ? 'd-block' : 'd-md-block'} ${(eliminationType && shouldDisplayRoundNumbers(eliminationType.value)) ? 'round1' : `round${columnNumber}`}`}
        >
            <div
                className="section-header text-small text-medium text-center text-dark mb24"
            >
                {renderRoundLabel(eliminationType ? eliminationType.value : 'default', selectedDraw.rounds[round], true)}
            </div>
            <div className="spacer" />
            {selectedDraw.rounds[round].matches.map((match, i) => {
                // eslint-disable-next-line no-nested-ternary
                const playerId = match.position1 && match.position1.type
                    ? match.position1.type.value === 'player' ? match.position1.id : teamsDict[match.position1.id] && teamsDict[match.position1.id].players[0]
                    : null;
                const oopInfo = orderOfPlay?.find(oop => oop.matchId === match.id);
                let displayTime = true;
                if (oopInfo && !oopInfo.includesTime) {
                    displayTime = false;
                }
                if (match.result) {
                    return (
                        <ScoreCard
                            key={match.id}
                            {...match.result}
                            forceCardView={true}
                            gameType={drawFormatType.value}
                            eliminationType={eliminationType && eliminationType.value}
                            ballType={ballType}
                            isEventScore={true}
                            match={match}
                            matchPosition={match.matchPosition}
                            playerId={playerId}
                            drawId={selectedDraw.id}
                            roundNumber={rounds[round].roundNumber}
                            roundSize={rounds[round].matches.length}
                            round={rounds[round]}
                            roundIndex={round}
                            matchIndex={i}
                            position1={match.position1}
                            position2={match.position2}
                            position1Seed={match.position1Seed}
                            position2Seed={match.position2Seed}
                            playersDict={playersDict}
                            teamsDict={teamsDict}
                            showDecimals={isCurrentMemberAdmin}
                            utrType={utrType.value}
                            timeZoneValue={eventSchedule.timeZone.value}
                            showDate={showMatchDates}
                            date={match.date}
                            detail={match.detail}
                            matchId={match.id}
                            showLocation={true}
                            events={events}
                            displayTime={displayTime}
                            isOfficialHSEvent={isOfficialHSEvent}
                            showContacts={isFlexLeagueEvent}
                            sportTypeId={sportTypeId}
                        />
                    );
                }

                return (
                    <ScoreCardBlank
                        key={match.id}
                        {...match}
                        playersDict={playersDict}
                        teamsDict={teamsDict}
                        gameType={drawFormatType.value}
                        eliminationType={eliminationType && eliminationType.value}
                        drawId={selectedDraw.id}
                        roundNumber={rounds[round].roundNumber}
                        roundSize={rounds[round].matches.length}
                        round={rounds[round]}
                        roundIndex={round}
                        matchIndex={i}
                        timeZoneValue={eventSchedule.timeZone.value}
                        showDecimals={isCurrentMemberAdmin}
                        utrType={utrType.value}
                        showDate={showMatchDates}
                        detail={match.detail}
                        matchId={match.id}
                        showLocation={true}
                        events={events}
                        displayTime={displayTime}
                        isOfficialHSEvent={isOfficialHSEvent}
                        showContacts={isFlexLeagueEvent}
                        ballType={ballType}
                        sportTypeId={sportTypeId}
                    />
                );
            })}
        </div>
    );
};

export default Round;
